// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Hk1d","inner":"Footer_inner__2A8Rq","nextIcon":"Footer_nextIcon__3FmX2","innerLeft":"Footer_innerLeft__23S9Y"};